export default __webpack_public_path__ + "static/media/MP.92fe4915.png";